// src/services/FieldGroupService.js

import http from "./http";

const FieldGroupService = {
  /**
   * Get table descriptor by id
   * @param {string} fieldId - The table descriptor id
   * @returns {Promise<Object|null>} - Returns table descriptor object with is_pages_hyper_link and url fields
   */
  getTableDescriptorById: async (fieldId) => {
    try {
      const response = await http.GET(`field-groups/table-descriptor/${fieldId}`);
      if (response.status === 200 && response.data) {
        const responseData = response.data;
        if (responseData.code === 200 && responseData.data) {
          return responseData.data;
        }
      }
      return null;
    } catch (error) {
      console.error('Error fetching table descriptor:', error);
      return null;
    }
  }
};

export default FieldGroupService;

